module.exports = __webpack_public_path__ + "static/img/立体仓库.301b1ad8.png";